import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import useBazaarVoice from 'hooks/useBazaarVoice';
import BVHelmet from './BVHelmet';
const BVRatingSummary = t0 => {
  const $ = _c(3);
  const {
    productId
  } = t0;
  useBazaarVoice();
  if (!productId) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <BVHelmet />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== productId) {
    t2 = <>{t1}<div data-bv-show="rating_summary" data-bv-product-id={productId} /></>;
    $[1] = productId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
BVRatingSummary.propTypes = {
  productId: PropTypes.string
};
export default BVRatingSummary;